
<template>
  <v-container class="ma-0">
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Ανταλλακτικά σε παραγγελία</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="lineItems"
      :search="search"
      loading: false
      :item-class="rowClass"
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      show-group-by
      :expanded.sync="expanded"
    >
<template v-slot:top>
      <v-toolbar
        flat
        ma=8
      >
      <v-row>
            <v-col cols="12" sm="4">
              <v-combobox
                v-model="vehicle"
                :items="uniqueVehicles"
                prepend-icon="mdi-truck"
                label="Όχημα"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(vehicle, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
              <v-col cols=12 sm="4">
               <v-select
                  :items=statuses
                  label="Κατάσταση"
                  v-model="status"
                  persistent-hint
                  item-text="Description"
                  item-value="Id"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
              <v-combobox
                v-model="tech"
                :items="uniqueTechs"
                prepend-icon="mdi-hammer-wrench"
                label="Τεχνικοί"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(tech, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            </v-row>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent max-width="700px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" class="ml-2 white--text" v-bind="attrs" v-on="on">
              <v-icon left>mdi-cart-plus</v-icon> Νέα Προπαραγγελία
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="d-flex align-center">
              <v-icon class="mr-2">mdi-cart-plus</v-icon>
              Νέα προπαραγγελία
              <v-spacer />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-form ref="preorderForm">
                <v-container fluid>
                  <v-row dense>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Κωδ. Κατασκευαστή" :rules="[rules.required]" v-model="editedItem.ManufacturerSku" hide-details="auto" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Κωδ. Προμηθευτή" v-model="editedItem.SupplierSku" hide-details="auto" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Κατασκευαστής" v-model="editedItem.Manufacturer" hide-details="auto" />
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12" sm="12">
                      <v-autocomplete
                        v-model="editedItem.PartId"
                        :loading="loading"
                        :items="parts"
                        :search-input.sync="searchParts"
                        hide-details
                        placeholder="Αναζήτηση με # για SKU, @ για αντιστοιχίες. * για wildcard."
                        item-text='Description'
                        item-value='Id'
                        no-filter
                        :hint="`${select.FmSku} ${select.Id}`"
                        persistent-hint
                        label="Ανταλλακτικό"
                      >
                        <template v-slot:selection="data">
                          {{ data.item.Id }}: {{ data.item.FmSku }} - {{ data.item.Description }}
                        </template>
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.FmSku"></v-list-item-title>
                              <v-list-item-subtitle v-html="data.item.Description"></v-list-item-subtitle>
                              <v-list-item-subtitle v-html="data.item.matchReason"></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε:
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                <v-btn icon @click="clearOrder(0)"><v-icon>mdi-trash-can</v-icon></v-btn>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field label="Σχόλια" v-model="editedItem.Remarks" hide-details="auto" />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-combobox
                        v-model="selectedVehicle"
                        :items="vehicles"
                        item-text="PlateNumber"
                        item-value="Id"
                        label="Όχημα πελάτη"
                        prepend-icon="mdi-truck"
                        hide-details
                      />
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="6" sm="4" md="3">
                      <v-text-field label="Ποσότητα" :rules="[rules.required]" v-model.number="editedItem.Qty" type="number" hide-details="auto" />
                    </v-col>
                    <v-col cols="6" sm="4" md="3">
                      <v-select label="Μονάδα Μέτρησης" v-model="editedItem.Unit" :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡΟ', 'ΩΡΑ','ΚΥΒΙΚΑ', '']" hide-details />
                    </v-col>
                    <v-col cols="6" sm="4" md="3">
                      <v-select label="Κατάσταση" :rules="[rules.required]" v-model="editedItem.Status" :items="statuses" item-text="Description" item-value="Id"  hide-details />
                    </v-col>
                    <v-col cols="6" sm="4" md="3">
                      <v-select label="Τεχνικός" :rules="[rules.required]" v-model="editedItem.TechId" :items="technicians" item-text="Name" item-value="Id" hide-details />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialog = false">Κλείσιμο</v-btn>
              <v-btn color="primary" text @click="savePreorder">Αποθήκευση</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

<template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleDateString()  }}
    </template>
    
    <template v-slot:item.actions="{ item }">
      <v-btn icon small class="mr-1" @click.stop="openView(item)"><v-icon>mdi-eye</v-icon></v-btn>
      <v-btn icon small class="mr-1" @click.stop="openEdit(item)"><v-icon>mdi-pencil</v-icon></v-btn>
      <v-btn icon small color="red" @click.stop="deletePreorder(item)"><v-icon>mdi-delete</v-icon></v-btn>
      <v-btn class="mr-2" icon small :to="{name: 'edit-repair', params: {repairId: item.RepairId}, target: '_blank'}"><v-icon>mdi-car-wrench</v-icon></v-btn>
    </template>
     <template v-slot:item.Price="{ item }">
       {{ tocurr(item.Price) }}
    </template>
     <template v-slot:item.netvalue="{ item }">
       {{ tocurr(item.NetValue) }}
    </template>
    <template v-slot:item.totalvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*1.24) }}
    </template>
    <template v-slot:item.vatvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*0.24) }}
    </template>

     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.ItemCode }}
      </td>
    </template>



    </v-data-table>
  </v-card>

  <v-dialog
    v-model="viewDialog"
    max-width="720px"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-eye</v-icon>
        Πληροφορίες Προπαραγγελίας
        <v-spacer></v-spacer>
        <v-chip v-if="selectedPreorder" small>{{ selectedPreorder.Status }}</v-chip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container v-if="selectedPreorder" fluid>
          <v-row dense>
            <v-col cols="12" class="d-flex align-center justify-space-between">
              <div class="text-subtitle-2 font-weight-medium">
                {{ (selectedPreorder.PartInfo && selectedPreorder.PartInfo.Description) || selectedPreorder.Description || '-' }}
              </div>
              <div>
                <v-btn icon small :to="{ name: 'part-info', params: { id: selectedPreorder.PartId } }" :disabled="!selectedPreorder.PartId">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="grey--text text--darken-1 caption">Αρ. Προπαραγγελίας</div>
              <div class="text-body-2">{{ selectedPreorder.Id || '-' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="grey--text text--darken-1 caption">Ημ/νία</div>
              <div class="text-body-2">{{ selectedPreorder.Timestamp ? new Date(selectedPreorder.Timestamp).toLocaleString() : '-' }}</div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" class="d-flex align-start">
              <div class="flex-grow-1">
                <div class="grey--text text--darken-1 caption">Όχημα</div>
                <div class="text-body-2">{{ (selectedPreorder.Vehicle && selectedPreorder.Vehicle.PlateNumber) || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-start">
              <div class="flex-grow-1">
                <div class="grey--text text--darken-1 caption">Τεχνικός</div>
                <div class="text-body-2">{{ selectedPreorder.Tech || (selectedPreorder.User && selectedPreorder.User.Name) || '-' }}</div>
              </div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="grey--text text--darken-1 caption">Κωδικός Προμηθευτή</div>
              <div class="text-body-2">{{ selectedPreorder.SupplierSku || '-' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="grey--text text--darken-1 caption">Κωδικός Κατασκευαστή</div>
              <div class="text-body-2">{{ selectedPreorder.ManufacturerSku || '-' }}</div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="grey--text text--darken-1 caption">Ποσότητα</div>
              <div class="text-body-2">{{ selectedPreorder.Qty || 0 }} {{ selectedPreorder.Unit || '' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="grey--text text--darken-1 caption">Τιμή</div>
              <div class="text-body-2">{{ tocurr(selectedPreorder.Price || 0) }}</div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <div class="grey--text text--darken-1 caption">Σχόλια</div>
              <div class="text-body-2">{{ selectedPreorder.Remarks || '-' }}</div>
            </v-col>
          </v-row>
          <v-expansion-panels flat class="mt-2">
            <v-expansion-panel>
              <v-expansion-panel-header>Πλήρη δεδομένα</v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre class="text-body-2" style="white-space: pre-wrap;">{{ JSON.stringify(selectedPreorder, null, 2) }}</pre>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
        <div v-else class="text-center grey--text">Δεν υπάρχει διαθέσιμη πληροφορία.</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="viewDialog = false">Κλείσιμο</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    </v-container>
</template>


<script>


export default {
  components: {
  },
  computed: {
  
    uniqueVehicles () {
      return this.uniq(this.lineItems, 'PlateNumber');
    },
     uniqueTechs () {
      return this.uniq(this.lineItems, 'Tech');
    },
  },
  data() {
    return {
      expanded: [],
      dialog: false,
      loading: true,
      search: '',
      vehicle: '',
      tech: '',
      customer_id: this.$route.params.gid,
      lineItems: [],
      parts: [],
      allParts: [],
      searchParts: '',
      select: '',
      vehicles: [],
      selectedVehicle: null,
      technicians: [],
      selectedPreorder: null,
      viewDialog: false,
      rules: {
        required: value => !!value || 'Required.',
        qty: value => value <= this.order.StockQty || 'Out of stock!',
        limit: value => value <= this.editedItem.Limit || 'Τιμή κάτω του κόστους'

      },
      editedItem: {
        Id: 0,
        ManufacturerSku: null,
        Manufacturer: null,
        SupplierId: null,
        RepairId: null,
        Remarks: '',
        Qty: 1,
        Unit: 'ΤΕΜ',
        Price: 0,
        Status: -2,
        TechId: 1,
        PartId: null,
      },
      status: null,
      statuses: [
        { Id: -2, Description: 'Ζήτηση' },
        { Id: -1, Description: 'Παραγγελία' },
        { Id: 0, Description: 'Παρελήφθη' },
        { Id: 1, Description: 'Ολοκληρωμένη' },
      ],
      headers: [
         {
            text: 'Ημ/νία',
            value: 'Timestamp',
            sortable: true,
            width: '5%',
            groupable: false,
          },
           {
            text: 'Όχημα',
            value: 'Vehicle.PlateNumber',
            sortable: true,
            width: '10%',
            groupable: true,
             filter: (value) => {
            if (this.vehicle.length == 0) return true;
            return this.vehicle.includes(value);
          }},
          { text: 'Κατασκευαστής', value: 'Manufacturer', width: '10%' },
          { text: 'Κωδικός', value: 'SupplierSku', width: '10%', groupable: true },
          { text: 'Περιγραφή', value: 'PartInfo.Description' },
           { text: 'Τεχνικός', value: 'Tech', sortable: false,
            filter: (value) => {
            if (this.tech.length == 0) return true;
            return this.tech.includes(value);
          }},
        { text: 'Ποσότητα', value: 'Qty', align: 'center', groupable: false  },
        { text: 'Μονάδα Μέτρησης', value: 'Unit', align: 'center', groupable: false  },
        { text: 'Τιμή', value: 'Price', align: 'end', groupable: false  },
          { text: 'Κατάσταση', value: 'Status', groupable: false, width: '5%',
          filter: (value) => {
            if (this.status === null) return true;
            return value == this.status;
            },
          },
        // { text: 'Καθαρή αξία', value: 'NetValue', align: 'end', groupable: false  },
        //  { text: 'ΦΠΑ', value: 'vatvalue', align: 'end', groupable: false },
        //  { text: 'Συνολο', value: 'totalvalue', align: 'end', groupable: false},
          { text: 'Actions', value: 'actions', groupable: false },
        ],
    }
  },
  async created() {
      try {
        this.loading = true
        const cid = this.$route.params.id
        const response = await this.$api.get(`/customers/preorders/${cid}`);
        this.lineItems = response.data;
        // fetch vehicles for this customer
        const veh = await this.$api.get(`/customers/vehicles/${cid}`);
        this.vehicles = veh.data || [];
        // technicians
        const techs = await this.$api.get('/repairs/technicians/');
        this.technicians = techs.data || [];
        // parts for autocomplete
        const partsResp = await this.$api.get('/inventory/items', { params: { limit: 4000 }});
        this.allParts = partsResp.data || [];
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
    searchParts(val) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
        this.fetchFilteredParts(val);
        }, 300); // Adjust the delay as needed
    },
},
  methods: {
  openView(item) {
      this.selectedPreorder = item;
      this.viewDialog = true;
    },
  openEdit(item) {
      this.editedItem = { ...item };
      this.selectedVehicle = item.Vehicle || (this.vehicles.find(v => v.Id === (item.VehicleId || (item.Vehicle && item.Vehicle.Id))) || null);
      this.dialog = true;
    },
  async deletePreorder(item) {
      if (!item || !item.Id) return;
      if (!confirm(`Διαγραφή προπαραγγελίας #${item.Id};`)) return;
      try {
        await this.$api.delete(`/inventory/preorders/${item.Id}`);
        const cid = this.$route.params.id;
        const response = await this.$api.get(`/customers/preorders/${cid}`);
        this.lineItems = response.data;
      } catch (e) {
        console.error('Failed to delete preorder', e);
      }
    },
  savePreorder: async function() {
      try {
        // Map selected vehicle to RepairId if your API expects RepairId directly; otherwise use VehicleId in payload
        const payload = { ...this.editedItem };
        if (this.selectedVehicle) {
          payload.VehicleId = this.selectedVehicle.Id;
        }
        // Create vs patch by Id
        if (payload.Id && payload.Id > 0) {
          await this.$api.patch(`/inventory/preorders/${payload.Id}`, payload);
        } else {
          await this.$api.post('/inventory/preorders/create', payload);
        }
        this.dialog = false;
        // refresh list
        const cid = this.$route.params.id
        const response = await this.$api.get(`/customers/preorders/${cid}`);
        this.lineItems = response.data;
      } catch(e) {
        console.error('Failed to save preorder', e);
      }
    },
    prependPrefix(prefix) {
      // Define the possible prefixes
      const prefixes = ['#', '!', '@', '$'];

      // Check if orderSearch is defined and not empty
      if (this.searchParts) {
        // Remove existing prefix if present
        const firstChar = this.searchParts.charAt(0);
        if (prefixes.includes(firstChar)) {
          this.searchParts = this.searchParts.substring(1);
        }
      }

      // Prepend the new prefix
      this.searchParts = prefix + (this.searchParts || '');
    },
    fetchFilteredParts(queryText) {
      if (queryText==null) return;

      this.loading = true;

      // Determine the search mode based on the prefix
      const isSkuSearch = queryText.startsWith('#');
      const isRefSearch = queryText.startsWith('@');
      const isIdSearch = queryText.startsWith('!');
      let searchText = '';
      if (isRefSearch || isSkuSearch || isIdSearch) {
        searchText = queryText.slice(1).toUpperCase(); // Remove prefix for actual search
      } else {
        searchText = queryText.toUpperCase(); // To uppercase for search
      }

      // Convert '*' to a regex pattern for fuzzy matching
      const searchPattern = new RegExp('^' + searchText.replace(/[^\p{L}\p{N}\\*]/gu, '').replace(/\*/g, '.*') + '.*$', 'i');
      const searchSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\*/g, '.*') + '$', 'i');
      // Split the search text into individual terms
      const searchTerms = searchText.split(/\s+/);

      // Simulate fetching data with filtering
      this.parts = this.allParts.filter(item => {
        const desc = item.Description.toUpperCase();
        const skus = item.FmSku.toUpperCase();
        const refs = item.References;

        // Fuzzy search for description
        // const descMatches = desc.includes(searchText) || searchPattern.test(desc);
        // Fuzzy search for description
        const descMatches = searchTerms.every(term => desc.includes(term));

        // Search in FmSku
        const skuMatches = searchSkuPattern.test(skus);

        // Search in References

        // const refMatches = refs.some(o => o.Sku.replace(/[^\p{L}\p{N}]/gu, '').includes(searchText));
        //const refMatches = refs.some(o => searchPattern.test(o.Sku.toUpperCase()));

        // Apply search logic based on the prefix
        // if (isSkuSearch) {
        //   return skuMatches || skus.includes(searchText);
        // } else if (isRefSearch) {
        //   return refMatches;
        // } else {
        //   return descMatches //|| skuMatches || refMatches;
        // }


        let matchReason = '';
        if (isSkuSearch) {
          if (skuMatches || skus.includes(searchText)) {
            matchReason = `Matched by SKU: ${searchText}`;
            item.matchReason = matchReason;
            return true;
          }
        } else if (isRefSearch) {
          const refMatches = refs.some(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
          if (refMatches) {
            const matchedRef = refs.find(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
            matchReason = `Matched by Reference: ${matchedRef ? matchedRef.Sku : ''}`;
            item.matchReason = matchReason;
            return true;
          }
        } else if (isIdSearch) {
            if (item.Id == searchText) {
              matchReason = `Matched by Id: ${searchText}`
              item.matchReason = matchReason;
              return true;
            }
        } else {
          if (descMatches) {
            matchReason = `Matched by Description: ${searchTerms.join(' ')}`;
            item.matchReason = matchReason;
            return true;
          }
        }

        return false;
      });
      this.loading = false;
    },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },
  rowClass (item) {
    return item.Status == 1 ? 'blue-grey lighten-4' : 'white darken-2';
  },
  uniq(items, key) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      for (let val of items) {
        //If item is already added then move to the next item
        if (itemsFound[val[key]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(val[key]);

        //Mark it as added
        itemsFound[val[key]] = true;
      }

      //Return the uniques
      return uniques;
    },
    remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },

  }
}
</script>